<template src="../templates/dashboard.pug" lang="pug"></template>
<style lang="sass" src="../sass/dashboard.sass" scoped></style>

<script>
import FarmForm from './form/FarmForm'
import FarmUserForm from './form/FarmUserForm'
import RegisterForm from './form/RegisterForm'
import FarmDataUploadForm from './form/FarmDataUploadForm'
import { mapGetters, mapActions } from 'vuex'
import LineChart from '../helpers/chart/inspection-result-small'
import _each from 'lodash/each'
import { format } from 'date-fns'
import { getRandomColor } from '../libs/color'
import $axios from '../axios'
import cyrillicToTranslit from 'cyrillic-to-translit-js'

export default {
    name: 'Dashboard',
    components: {
        FarmForm,
        FarmUserForm,
        RegisterForm,
        FarmDataUploadForm,
        LineChart
    },
    data() {
        return {
            showFarmForm: false,
            showFarmUserForm: false,
            showRegisterForm: false,
            showFarmDataUploadForm: false,
            farmToUpdate: {
                id: null,
                name: '',
                manager: '',
                address: ''
            },
            farmUserToUpdate: []
        }
    },
    computed: {
        ...mapGetters(['farms', 'profile', 'isUserManager', 'isUserAdmin', 'isMobile'])
    },
    mounted() {

        this.fetchProfile()
        this.fetchFarms()
        this.fetchBuildings()
        this.fetchSicknessList()
    },
    methods: {
        ...mapActions([
            'fetchFarms',
            'fetchBuildings',
            'fetchAnimals',
            'fetchSicknessList',
            'resetFarm',
            'updateInspections',
            'fetchProfile',
            'deleteFarm',
            'updateAnimals'
        ]),
        selectFarm(id) {

            if(this.isMobile) {
                this.$router.push('/pwa/cattle/' + id)
            } else {
                this.$router.push({name: 'farm-summary', params: {farmId: id}})
            }
        },
        goToUpdateFarm(farm) {
            this.$router.push({
                name: 'edit-farm-form',
                params: {
                    farmToUpdate: {
                        id: farm.id,
                        name: farm.name,
                        manager: farm.manager === null ? '' : farm.manager,
                        address: farm.address === null ? '' : farm.address
                    }
                }
            })
        },
        updateFarmUsers(farmUsers) {
            this.farmUserToUpdate = farmUsers
            this.showFarmUserForm = true
        },
        getLineChartData(inspections) {
            let chartData = {
                labels: [],
                datasets: [
                    {
                        label: 'Lait',
                        fill: false,
                        borderColor: '#00838F',
                        data: []
                    }
                ]
            }
            _each(inspections.slice(0, 6), function(i) {
                chartData.labels.push(format(new Date(i.date * 1000), 'MM/DD'))
                chartData.datasets[0]['data'].push(Math.round(i.average * 100) / 100)
            })
            return chartData
        },
        uploadFarmData(farm) {
            this.farmToUpdate.id = farm.id
            this.farmToUpdate.name = farm.name
            this.showFarmDataUploadForm = true
        },
        exportFarmData(farm) {
            $axios
                .get('/api/farm/export/' + farm.id, {
                    headers: { Accept: 'application/vnd.ms-excel' },
                    responseType: 'blob'
                })
                .then(response => {
                    let farmNameLat = cyrillicToTranslit().transform(farm.name, '_')
                    const url = window.URL.createObjectURL(new Blob([response.data]))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', '(data_export)' + farmNameLat + '.xlsx')
                    document.body.appendChild(link)
                    link.click()
                })
        },
        deleteFarmDialog(farm) {
            this.$dialog
                .confirm(this.$t('farm.dialog.message', { farm: farm.name }), {
                    okText: this.$t('button.true'),
                    cancelText: this.$t('button.false')
                })
                .then(() => {
                    this.deleteFarm(farm.id)
                })
                .catch(() => {})
        },
        resetFarmDialog(farm) {
            this.$dialog
                .confirm(this.$t('farm.dialog.reset', { farm: farm.name }), {
                    okText: this.$t('button.true'),
                    cancelText: this.$t('button.false')
                })
                .then(() => {
                    this.resetFarm(farm.id)
                })
                .catch(() => {})
        },
        getLastMilkInspection(f) {
            if(f.milkInspections.length > 0) {
                return Math.round(f.milkInspections[0].average * 10) / 10
            } else {
                return 0
            }
        },
        getRandomColor(int) {
            return getRandomColor(int)
        }
    }
}
</script>
